export default __webpack_public_path__ + "static/media/event.8a82802a.jpg";